export interface FAQItem {
  question: string;
  answer: string;
}

export const buyerFAQItems: FAQItem[] = [
  {
    question: "Como compro ingressos?",
    answer:
      "Acesse a página do evento, escolha ingressos e finalize o pagamento via PIX, cartão ou boleto. Seus ingressos chegam por e-mail e ficam disponíveis em 'Meus Ingressos'.",
  },
  {
    question: "É seguro comprar pelo TicketHall?",
    answer:
      "Sim. Usamos criptografia, não armazenamos dados completos de cartão e monitoramos transações para evitar fraudes. Seguimos LGPD e usamos gateways certificados.",
  },
  {
    question: "Posso transferir meu ingresso?",
    answer:
      "Sim. Na área 'Meus Ingressos', clique em 'Transferir' e informe o e-mail do novo titular. A transferência é gratuita e o recebimento é automático.",
  },
  {
    question: "Como funciona o reembolso?",
    answer:
      "Você pode falar com o produtor a qualquer momento pelo botão na página do evento. Em compras online, o direito de arrependimento segue o Código de Defesa do Consumidor. Em cancelamento, adiamento ou alteração relevante, o reembolso integral — incluindo taxas — deve ser disponibilizado ao consumidor.",
  },
  {
    question: "Meu ingresso é digital ou preciso imprimir?",
    answer:
      "Ingressos são digitais com QR Code. Apresente pelo celular no acesso, não é necessária impressão.",
  },
  {
    question: "Como funciona o check-in no evento?",
    answer:
      "Na entrada abra o ingresso e mostre o QR Code. O responsável escaneia e libera sua entrada, normalmente em segundos.",
  },
  {
    question: "Posso parcelar minha compra?",
    answer:
      "Cartão em até 12x (até 3x sem juros), além de PIX e boleto. Escolha a forma no checkout.",
  },
];

export const producerFAQItems: FAQItem[] = [
  {
    question: "Quanto custa usar a plataforma para vender ingressos?",
    answer:
      "Cobramos apenas uma taxa de 7% sobre as vendas de ingressos pagos. Eventos com ingressos totalmente gratuitos são 100% grátis e isentos de taxas. Não há mensalidade, taxa de adesão ou qualquer custo oculto.",
  },
  {
    question: "Como funciona o repasse dos valores das vendas?",
    answer:
      "Operamos no modelo 75/25: 75% do valor líquido das vendas fica disponível para saque imediato durante o período de vendas (antes do evento acontecer). Os 25% restantes são liberados para resgate em D+2 dias úteis após a conclusão do evento. O pagamento de saques via Pix ou TED é processado em até 1 dia útil.",
  },
  {
    question: "Posso criar eventos gratuitos e pagos na mesma conta?",
    answer:
      "Sim. Você pode publicar eventos com ingressos pagos, gratuitos ou mistos (com lotes de cortesias e lotes pagos rodando em paralelo), tendo controle total da distribuição.",
  },
  {
    question: "Consigo personalizar lotes, viradas e cupons de desconto?",
    answer:
      "Sim. Você pode criar lotes com quantidades e preços independentes, configurar viradas automáticas (por data/horário ou ao esgotar a quantidade) e oferecer cupons de desconto por valor fixo ou porcentagem, definindo limites de uso e validade.",
  },
  {
    question: "Como funciona o check-in no dia do evento?",
    answer:
      "O credenciamento é feito escaneando o QR Code exclusivo de cada ingresso. Você pode realizar o check-in usando o aplicativo da TicketHall no celular (mesmo offline e sem internet, com sincronização automática) ou diretamente através do painel do produtor, acompanhando os gráficos de entrada em tempo real.",
  },
  {
    question: "Dá para ter equipe com acessos diferentes para operar o evento?",
    answer:
      "Sim. Você pode convidar membros para a sua organização e atribuir funções específicas com diferentes níveis de permissão, como Administrador (controle total), Financeiro (saques e relatórios) e Staff (acesso restrito apenas para validar ingressos na portaria).",
  },
  {
    question: "Consigo vender itens extras além do ingresso?",
    answer:
      "Sim. A plataforma permite criar combos (como ingresso + copo ou camiseta do evento) ou vender produtos físicos, consumação antecipada e experiências adicionais diretamente no fluxo de compra do cliente.",
  },
  {
    question: "A plataforma oferece suporte para quem está começando?",
    answer:
      "Sim! Oferecemos um painel de criação totalmente guiado e intuitivo, além de documentação completa e suporte humanizado via chat e WhatsApp para ajudar você a configurar e operar seu evento sem complicações.",
  },
];

export const allFAQItems = { buyer: buyerFAQItems, producer: producerFAQItems };
